import { render, staticRenderFns } from "./StudentExerciseOverview.vue?vue&type=template&id=d513afd8&scoped=true"
import script from "./StudentExerciseOverview.vue?vue&type=script&lang=js"
export * from "./StudentExerciseOverview.vue?vue&type=script&lang=js"
import style0 from "./StudentExerciseOverview.vue?vue&type=style&index=0&id=d513afd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d513afd8",
  null
  
)

export default component.exports